import { isVNode } from 'vue';
import type { ExtractPropTypes, InjectionKey, PropType } from 'vue';
import type Descriptions from './descriptions.vue';

export const DescriptionsProps = {
  border: {
    type: Boolean,
    default: true,
  },
  columns: {
    type: Number,
    default: 1,
  },
  labelWidth: {
    type: String,
    default: '100px',
  },
  size: {
    type: String as PropType<'small' | 'default' | 'large'>,
    default: 'default',
  },
};

export const descriptionContextKey: InjectionKey<any> = Symbol('descriptionContextKey');

export type DescriptionsPropsType = ExtractPropTypes<typeof DescriptionsProps>;
export type DescriptionsInstance = InstanceType<typeof Descriptions>;

export interface IDescriptionItem {
  props: {
    key: number;
    label: string;
    span?: number;
    rowSpan?: number;
  };
  type: {
    name?: string;
  };
  _isPlaceholder?: boolean;
}

export const flattedChildren = (children: any): any => {
  const vNodes = Array.isArray(children) ? children : [children];
  const result: any[] = [];

  vNodes.forEach(child => {
    if (Array.isArray(child)) {
      result.push(...flattedChildren(child));
    } else if (isVNode(child) && child.component?.subTree) {
      result.push(child, ...flattedChildren(child.component.subTree));
    } else if (isVNode(child) && Array.isArray(child.children)) {
      result.push(...flattedChildren(child.children));
    } else if (isVNode(child) && child.shapeFlag === 2) {
      // eslint-disable-next-line ts/ban-ts-comment
      // @ts-expect-error
      result.push(...flattedChildren(child.type()));
    } else {
      result.push(child);
    }
  });
  return result;
};
